import { FC } from 'react';
import s from './OptionRow.module.css';
import { Button } from 'components/common/Button/Button';
import { ReactComponent as Arrow } from 'images/arrow.svg';

type OptionRowProps = {
  title: string;
  value: string;
  onClick: () => void;
};

export const OptionRow: FC<OptionRowProps> = ({ title, value, onClick }) => {
  return (
    <Button className={s.btn} onClick={onClick}>
      <span>{title}</span>
      <span className={s.value}>{value}</span>
      <Arrow className={s.arrow} />
    </Button>
  );
};
